import {useState} from 'react'
import {
    Dropdown,
    DROPDOWN_TYPE_CONDITION_BASE,
    DROPDOWN_TYPE_METRIC,
    DROPDOWN_TYPE_CONDITION_OPERATOR,
    DROPDOWN_TYPE_REWARD_OPERATOR,
    DROPDOWN_TYPE_REWARD_BASE,
    conditionBaseValues,
    operatorValues,
    mathematicalOperationValues, rewardBaseValues, metricValues
} from "../shared/Dropdow";
import {Snackbar} from "../shared/Snackbar";
import {HiOutlineCalendar, HiPlus, HiOutlineTrash} from "react-icons/hi";
import {Toggle} from "../shared/Toggle";
import {useDispatch} from "react-redux";
import {createCampaignAction} from "../../redux/actions/campaignActions";
import {generateUniqueId} from "../../utils/idUtils";
import Modal from "../shared/Modal";
import Button from "../shared/Button";
import TextInput from "../shared/TextInput";
import Card from "../shared/Card";

//TODO export constants
const TRANSACTION = "transaction"

export const FRAUD_PREVENTION_MAX_POINTS = "fraud_prevention_max_points"
export const FRAUD_PREVENTION_MAX_TRANSACTIONS = "fraud_prevention_max_transactions"

export default function CampaignBuilderModal(props) {
    const dispatch = useDispatch();
    const [missingValue, setMissingValue] = useState(null)
    const [snackbarMessage, setSnackbarMessage] = useState(null)

    const newConditionData = () => ({
        id: generateUniqueId(),
        type: TRANSACTION,
        inputValue: "",
        transactionBase: conditionBaseValues[0],
        transactionOperator: operatorValues[0],
        valueMetric: metricValues[0]
    })

    const newRewardsData = () => ({
        id: generateUniqueId(),
        rewardBase: rewardBaseValues[0],
        operator: mathematicalOperationValues[0],
        points: null
    })

    const newCampaignInitialData = () => ({
        name: "",
        conditions: [newConditionData()],
        rewards: [newRewardsData()],
        fraudPrevention: {},
        startDate: "",
        endDate: ""
    })

    const [newCampaign, setNewCampaign] = useState(newCampaignInitialData())
    const [enableTimeframe, setEnableTimeframe] = useState(false)

    // Minimum allowed startDate (now, formatted for datetime-local: YYYY-MM-DDTHH:MM)
    const minStartDate = (() => {
        const now = new Date();
        const offsetMs = now.getTimezoneOffset() * 60 * 1000;
        return new Date(now.getTime() - offsetMs).toISOString().slice(0, 16);
    })();

    const recreateBuilder = () => {
        let newBuilder = Object.assign({}, newCampaign);
        setNewCampaign(newBuilder);
    }

    const setSelected = (conditionRewardId, type, dropdownValue) => {
        if (type === DROPDOWN_TYPE_CONDITION_BASE) {
            newCampaign.conditions.find(condition => condition.id === conditionRewardId).transactionBase = dropdownValue;
        } else if (type === DROPDOWN_TYPE_CONDITION_OPERATOR) {
            newCampaign.conditions.find(condition => condition.id === conditionRewardId).transactionOperator = dropdownValue;
        } else if (type === DROPDOWN_TYPE_METRIC) {
            newCampaign.conditions.find(condition => condition.id === conditionRewardId).valueMetric = dropdownValue;
        } else if (type === DROPDOWN_TYPE_REWARD_BASE) {
            newCampaign.rewards.find(reward => reward.id === conditionRewardId).rewardBase = dropdownValue;
        } else if (type === DROPDOWN_TYPE_REWARD_OPERATOR) {
            newCampaign.rewards.find(reward => reward.id === conditionRewardId).operator = dropdownValue;
        }
    }

    const handleAddCondition = () => {
        try {
            let mValue = null;
            newCampaign.conditions.forEach(condition => {
                if (condition.inputValue.length === 0) {
                    mValue = condition.id;
                }
            })

            if (mValue) {
                setMissingValue(mValue);
                setInterval(() => setMissingValue(null), 5000);
            } else {
                newCampaign.conditions.push(newConditionData());
                recreateBuilder()
            }
        } catch (e) {
        }
    }

    const handleAddReward = () => {
        try {
            let mValue = null;
            newCampaign.rewards.forEach(reward => {
                if (!reward.points || reward.points.length === 0) {
                    mValue = reward.id;
                }
            })

            if (mValue) {
                setMissingValue(mValue);
                setInterval(() => setMissingValue(null), 5000);
            } else {
                newCampaign.rewards.push(newRewardsData());
                recreateBuilder()
            }
        } catch (e) {
        }
    }

    const renderConditionRow = (conditionId) => {
        return (
            <Card key={conditionId} variant="surface-soft" className="p-4">
                <div className="flex flex-row gap-2 items-center flex-wrap">
                    <Dropdown id={conditionId} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_CONDITION_BASE}/>
                    <Dropdown id={conditionId} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_CONDITION_OPERATOR}/>
                    <div className="w-28">
                        <TextInput
                            id="conditionBuilderInput"
                            type="number"
                            placeholder="Value"
                            error={missingValue === conditionId ? "Required" : undefined}
                            value={newCampaign.conditions.find(condition => condition.id === conditionId)?.inputValue}
                            onChange={(event) => {
                                const realValue = event.target.value < 0 ? 0 : event.target.value;
                                const entry = newCampaign.conditions.find(condition => condition.id === conditionId)
                                if (entry) {
                                    entry.inputValue = realValue
                                }
                                recreateBuilder()
                            }}
                        />
                    </div>
                    <Dropdown id={conditionId} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_METRIC}/>
                    <button
                        type="button"
                        onClick={()=> {
                            newCampaign.conditions = newCampaign.conditions.filter(condition => condition.id !== conditionId);
                            recreateBuilder()
                        }}
                        className="ml-auto inline-flex items-center justify-center w-10 h-10 rounded-full text-signature-coral hover:bg-canvas transition-colors"
                        aria-label="Remove condition"
                    >
                        <HiOutlineTrash className="w-5 h-5" />
                    </button>
                </div>
            </Card>
        );
    }

    const renderRewardRow = (rewardId) => {
        return (
            <Card key={rewardId} variant="surface-soft" className="p-4">
                <div className="flex flex-row gap-2 items-center flex-wrap">
                    <span className="text-body-md text-body">Add points:</span>
                    <Dropdown id={rewardId} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_REWARD_BASE}/>
                    <Dropdown id={rewardId} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_REWARD_OPERATOR}/>
                    <div className="w-28">
                        <TextInput
                            type="number"
                            placeholder="Points"
                            error={missingValue === rewardId ? "Required" : undefined}
                            value={newCampaign.rewards.find(reward => reward.id === rewardId)?.points ?? ""}
                            onChange={(event) => {
                                const realPoints = event.target.value < 0 ? 0 : event.target.value;
                                const entry = newCampaign.rewards.find(reward => reward.id === rewardId)
                                if (entry) {
                                    entry.points = realPoints
                                }
                                recreateBuilder()
                            }}
                        />
                    </div>
                    <button
                        type="button"
                        onClick={()=> {
                            newCampaign.rewards = newCampaign.rewards.filter(reward => reward.id !== rewardId);
                            recreateBuilder()
                        }}
                        className="ml-auto inline-flex items-center justify-center w-10 h-10 rounded-full text-signature-coral hover:bg-canvas transition-colors"
                        aria-label="Remove reward"
                    >
                        <HiOutlineTrash className="w-5 h-5" />
                    </button>
                </div>
            </Card>
        );
    }

    const handleCreate = async () => {
        try {
            if (newCampaign.name.length === 0) {
                setMissingValue("name");
                setSnackbarMessage("Please enter a campaign name");
                return;
            }

            if (newCampaign.conditions.length === 0) {
                setSnackbarMessage("Add at least one condition");
                return;
            }

            const invalidCondition = newCampaign.conditions.some(
                condition => condition.inputValue === undefined
                    || condition.inputValue === null
                    || String(condition.inputValue).length === 0
                    || !(Number(condition.inputValue) > 0)
            );
            if (invalidCondition) {
                setSnackbarMessage("Condition values must be greater than 0");
                return;
            }

            if (newCampaign.rewards.length === 0) {
                setSnackbarMessage("Add at least one reward");
                return;
            }

            const invalidReward = newCampaign.rewards.some(
                reward => reward.points === undefined
                    || reward.points === null
                    || String(reward.points).length === 0
                    || !(Number(reward.points) > 0)
            );
            if (invalidReward) {
                setSnackbarMessage("Reward points must be greater than 0");
                return;
            }

            if (!newCampaign.fraudPrevention.maxPoints ||
                !Number.isInteger(Number(newCampaign.fraudPrevention.maxPoints)) ||
                Number(newCampaign.fraudPrevention.maxPoints) < 1) {
                setMissingValue(FRAUD_PREVENTION_MAX_POINTS);
                setSnackbarMessage("Please enter a valid maximum points value");
                return;
            }

            if (!newCampaign.fraudPrevention.maxTransactions ||
                !Number.isInteger(Number(newCampaign.fraudPrevention.maxTransactions)) ||
                Number(newCampaign.fraudPrevention.maxTransactions) < 1) {
                setMissingValue(FRAUD_PREVENTION_MAX_TRANSACTIONS);
                setSnackbarMessage("Please enter a valid maximum transactions value");
                return;
            }

            // Convert datetime-local (timezone-naive local) to ISO UTC,
            // and force endDate to end-of-day so picking just a date
            // includes the whole final day.
            let startDateISO = null;
            let endDateISO = null;
            if (enableTimeframe) {
                if (newCampaign.startDate) {
                    const start = new Date(newCampaign.startDate);
                    if (Number.isNaN(start.getTime())) {
                        setSnackbarMessage("Invalid start date");
                        return;
                    }
                    startDateISO = start.toISOString();
                }
                if (newCampaign.endDate) {
                    const end = new Date(newCampaign.endDate);
                    if (Number.isNaN(end.getTime())) {
                        setSnackbarMessage("Invalid end date");
                        return;
                    }
                    end.setHours(23, 59, 59, 999);
                    endDateISO = end.toISOString();
                }
                if (startDateISO && endDateISO && new Date(endDateISO) <= new Date(startDateISO)) {
                    setSnackbarMessage("End date must be after start date");
                    return;
                }
            }

            const campaignToSend = {
                ...newCampaign,
                startDate: startDateISO,
                endDate: endDateISO
            };

            const result = await dispatch(createCampaignAction(campaignToSend));
            if (result.success) {
                props.closeModal();
            }
        } catch (e) {
            setSnackbarMessage(e.message || "Error creating campaign. Please try again.");
        }
    }

    return (
        <>
            {snackbarMessage ? <Snackbar text={snackbarMessage}/> : null}
            <Modal
                isOpen={true}
                onClose={props.closeModal}
                title="New campaign"
                description="Set up rules, rewards, and fraud limits for your campaign."
                size="lg"
                footer={
                    <>
                        <Button variant="secondary" onClick={props.closeModal}>Cancel</Button>
                        <Button variant="primary" onClick={handleCreate}>Create campaign</Button>
                    </>
                }
            >
                <div className="space-y-8">
                    {/* Name */}
                    <TextInput
                        label="Campaign Name"
                        placeholder="Enter campaign name"
                        error={missingValue === "name" ? "Campaign name is required" : undefined}
                        value={newCampaign.name}
                        onChange={(event) => {
                            newCampaign.name = event.target.value;
                            recreateBuilder()
                        }}
                    />

                    {/* Duration */}
                    <div>
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-title-md text-ink">Campaign Duration</h3>
                            <Toggle
                                checked={enableTimeframe}
                                onChange={e => setEnableTimeframe(e.target.checked)}
                                label="Enable timeframe"
                            />
                        </div>
                        {enableTimeframe && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <TextInput
                                    label="Start Date"
                                    type="datetime-local"
                                    min={minStartDate}
                                    leadingIcon={<HiOutlineCalendar className="w-4 h-4" />}
                                    value={newCampaign.startDate}
                                    onChange={(event) => {
                                        newCampaign.startDate = event.target.value;
                                        recreateBuilder()
                                    }}
                                />
                                <TextInput
                                    label="End Date"
                                    type="datetime-local"
                                    min={newCampaign.startDate || minStartDate}
                                    leadingIcon={<HiOutlineCalendar className="w-4 h-4" />}
                                    value={newCampaign.endDate}
                                    onChange={(event) => {
                                        newCampaign.endDate = event.target.value;
                                        recreateBuilder()
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    {/* Rules */}
                    <div>
                        <h3 className="text-title-md text-ink mb-4">Campaign Rules</h3>
                        <p className="text-body-md text-muted mb-3">Conditions</p>
                        <div className="space-y-3">
                            {newCampaign.conditions.map((condition) => renderConditionRow(condition.id))}
                        </div>
                        <div className="mt-3">
                            <Button
                                variant="secondary"
                                size="sm"
                                leadingIcon={<HiPlus className="w-4 h-4" />}
                                onClick={handleAddCondition}
                            >
                                Add Condition
                            </Button>
                        </div>

                        <div className="border-t border-hairline my-6" />

                        <p className="text-body-md text-muted mb-3">Rewards</p>
                        <div className="space-y-3">
                            {newCampaign.rewards.map((rewards) => renderRewardRow(rewards.id))}
                        </div>
                        <div className="mt-3">
                            <Button
                                variant="secondary"
                                size="sm"
                                leadingIcon={<HiPlus className="w-4 h-4" />}
                                onClick={handleAddReward}
                            >
                                Add Reward
                            </Button>
                        </div>
                    </div>

                    {/* Fraud Prevention */}
                    <div>
                        <h3 className="text-title-md text-ink mb-4">Fraud Prevention</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <TextInput
                                label="Max Points per Member"
                                type="number"
                                placeholder="Enter max points"
                                error={missingValue === FRAUD_PREVENTION_MAX_POINTS ? "Required" : undefined}
                                value={newCampaign.fraudPrevention.maxPoints ?? ""}
                                onChange={(event) => {
                                    newCampaign.fraudPrevention.maxPoints = event.target.value
                                    recreateBuilder()
                                }}
                            />
                            <TextInput
                                label="Max Transactions per Member"
                                type="number"
                                placeholder="Enter max transactions"
                                error={missingValue === FRAUD_PREVENTION_MAX_TRANSACTIONS ? "Required" : undefined}
                                value={newCampaign.fraudPrevention.maxTransactions ?? ""}
                                onChange={(event) => {
                                    newCampaign.fraudPrevention.maxTransactions = event.target.value
                                    recreateBuilder()
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
